<script>
  export default {
    name: 'Menu',
  }
</script>

<template>
  <!-- STRAT NAVBAR -->
  <nav
    class="navbar navbar-expand-lg fixed-top navbar-white navbar-custom sticky sticky-dark"
    id="navbar"
  >
    <div class="container">
      <!-- LOGO -->
      <a class="navbar-brand logo text-uppercase" href="/">
        <img
          src="@/assets/images/DIU.png"
          alt="logo-img"
          class="mx-auto img-fluid d-block"
        />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleMenu()"
      >
        <i class="mdi mdi-menu"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav navbar-center" id="mySidenav">
          <li class="nav-item">
            <a
              v-scroll-to="{ el: '#features', offset: -5 }"
              class="nav-link"
              data-scroll-spy-id="features"
              href="javascript: void(0);"
              >¿Quiénes somos?</a
            >
          </li>
          <li class="nav-item">
            <a
              v-scroll-to="{ el: '#services', offset: -5 }"
              class="nav-link"
              data-scroll-spy-id="services"
              href="javascript: void(0);"
              >¿Qué ofrecemos?</a
            >
          </li>
          <li class="nav-item">
            <a
              v-scroll-to="{ el: '#pricing', offset: -5 }"
              class="nav-link"
              data-scroll-spy-id="about"
              href="javascript: void(0);"
              >¿Qué buscamos?</a
            >
          </li>
        </ul>
        <div class="nav-button ml-auto">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <button
                type="button"
                v-scroll-to="{ el: '#contact' }"
                data-scroll-spy-id="contact"
                class="btn btn-custom navbar-btn btn-rounded"
              >
                Contáctanos
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
  <!-- END NAVBAR -->
</template>
